import { getVolumeId } from './getVolumeId.js';
export function resolveGenericViewportVolumeId(viewport, targetId) {
    const genericViewport = viewport;
    const actors = genericViewport.getActors?.() ?? [];
    const matchedActor = targetId
        ? (actors.find((actor) => actor.referencedId === targetId) ??
            actors.find((actor) => actor.referencedId?.endsWith(`:${targetId}`)))
        : undefined;
    return (matchedActor?.referencedId ??
        (targetId ? getVolumeId(targetId) : undefined) ??
        genericViewport.getDefaultActor?.()?.referencedId);
}
